import { Component, OnInit } from "@angular/core";
import { Store } from "@ngxs/store";
import { LoadUseMuster } from "../shared/state/prefill-data.actions";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html"
})
export class DashboardComponent implements OnInit {
  constructor(
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.dispatch(
      new LoadUseMuster()
    );
  }
}
